import { languageSelector } from '../languageSelector';
export var getHeaderNavLinks = function getHeaderNavLinks(nav, secondaryNav, userNav, lifePrimaryNav, qnaNav, qnaUserNav) {
  var userNavData = [{
    navUrl: 'my/account-next',
    navText: userNav[0],
    useAbsolute: false,
    configuration: null,
    __typename: 'NavLinkItem'
  }, {
    navUrl: 'https://www.mathway.com/Algebra',
    navText: userNav[1],
    useAbsolute: true,
    configuration: null,
    __typename: 'NavLinkItem'
  }, {
    navUrl: 'tools/writing-center',
    navText: userNav[2],
    useAbsolute: false,
    configuration: null,
    __typename: 'NavLinkItem'
  }, {
    navUrl: 'contactus',
    navText: userNav[3],
    useAbsolute: false,
    configuration: null,
    __typename: 'NavLinkItem'
  }, {
    navUrl: 'signout',
    navText: userNav[4],
    useAbsolute: false,
    configuration: null,
    __typename: 'NavLinkItem'
  }];
  var qnaUserNavData = [{
    navUrl: 'my/account-next',
    navText: qnaUserNav[0],
    useAbsolute: false,
    configuration: null,
    __typename: 'NavLinkItem'
  }, {
    navUrl: 'https://www.mathway.com/Algebra',
    navText: qnaUserNav[3],
    useAbsolute: true,
    configuration: null,
    __typename: 'NavLinkItem'
  }, {
    navUrl: 'tools/writing-center',
    navText: qnaUserNav[4],
    useAbsolute: false,
    configuration: null,
    __typename: 'NavLinkItem'
  }, {
    navUrl: 'contactus',
    navText: qnaUserNav[5],
    useAbsolute: false,
    configuration: null,
    __typename: 'NavLinkItem'
  }, {
    navUrl: 'signout',
    navText: qnaUserNav[6],
    useAbsolute: false,
    configuration: null,
    __typename: 'NavLinkItem'
  }];
  return {
    DefaultSignedInHeader: {
      desktop: {
        userNav: userNavData,
        languageSelector: {
          languageSelectorChildren: languageSelector.children,
          languageSelectorConfiguration: {
            navType: 'LANGUAGE_SELECTOR',
            iconPosition: '1',
            __typename: 'NavConfiguration'
          },
          __typename: 'LanguageSelectorElement'
        },
        __typename: 'NavData'
      }
    },
    lifeSignedInHeader: {
      desktop: {
        primaryNav: [{
          parent: {
            navUrl: 'life/money',
            navText: lifePrimaryNav[0],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          },
          children: null,
          __typename: 'NavElement'
        }, {
          parent: {
            navUrl: 'life/health-and-wellness',
            navText: lifePrimaryNav[1],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          },
          children: null,
          __typename: 'NavElement'
        }, {
          parent: {
            navUrl: 'life/life-skills',
            navText: lifePrimaryNav[2],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          },
          children: null,
          __typename: 'NavElement'
        }, {
          parent: {
            navUrl: null,
            navText: lifePrimaryNav[3],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          },
          children: [{
            navUrl: 'life/about-us',
            navText: lifePrimaryNav[4],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          }, {
            navUrl: 'life/search',
            navText: lifePrimaryNav[5],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          }, {
            navUrl: 'life/resources/mental-health-resources',
            navText: lifePrimaryNav[6],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          }],
          __typename: 'NavElement'
        }],
        secondaryNav: [{
          parent: {
            navUrl: '/',
            navText: nav[0],
            useAbsolute: null,
            configuration: {
              externalApi: null,
              navIconUrl: 'HomeIcon',
              elementClassName: null,
              elementId: null,
              iconPosition: null,
              navType: null,
              __typename: 'NavConfiguration'
            },
            __typename: 'NavLinkItem'
          },
          children: null,
          __typename: 'NavElement'
        }, {
          parent: {
            navUrl: null,
            navText: nav[1],
            useAbsolute: null,
            configuration: {
              externalApi: null,
              navIconUrl: 'ToolsIcon',
              elementClassName: null,
              elementId: null,
              iconPosition: null,
              navType: null,
              __typename: 'NavConfiguration'
            },
            __typename: 'NavLinkItem'
          },
          children: [{
            navUrl: 'study/qa/post',
            navText: nav[2],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          }, {
            navUrl: 'math-solver',
            navText: nav[3],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          }, {
            navUrl: 'tools/writing-center',
            navText: nav[4],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          }],
          __typename: 'NavElement'
        }, {
          parent: {
            navUrl: 'career',
            navText: secondaryNav[0],
            useAbsolute: null,
            configuration: {
              externalApi: null,
              navIconUrl: 'CareerIcon',
              elementClassName: null,
              elementId: null,
              iconPosition: null,
              navType: null,
              __typename: 'NavConfiguration'
            },
            __typename: 'NavLinkItem'
          },
          children: null,
          __typename: 'NavElement'
        }],
        userNav: userNavData,
        languageSelector: {
          languageSelectorChildren: languageSelector.children,
          languageSelectorConfiguration: {
            navType: 'LANGUAGE_SELECTOR',
            iconPosition: '1',
            __typename: 'NavConfiguration'
          },
          __typename: 'LanguageSelectorElement'
        },
        __typename: 'NavData'
      }
    },
    perks: {
      desktop: {
        primaryNav: [{
          parent: {
            navUrl: '/',
            navText: nav[0],
            useAbsolute: null,
            configuration: {
              externalApi: null,
              navIconUrl: 'HomeIcon',
              elementClassName: null,
              elementId: null,
              iconPosition: null,
              navType: null,
              __typename: 'NavConfiguration'
            },
            __typename: 'NavLinkItem'
          },
          children: null,
          __typename: 'NavElement'
        }, {
          parent: {
            navUrl: null,
            navText: nav[1],
            useAbsolute: null,
            configuration: {
              externalApi: null,
              navIconUrl: 'ToolsIcon',
              elementClassName: null,
              elementId: null,
              iconPosition: null,
              navType: null,
              __typename: 'NavConfiguration'
            },
            __typename: 'NavLinkItem'
          },
          children: [{
            navUrl: 'study/qa/post',
            navText: nav[2],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          }, {
            navUrl: 'math-solver',
            navText: nav[3],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          }, {
            navUrl: 'tools/writing-center',
            navText: nav[4],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          }],
          __typename: 'NavElement'
        }, {
          parent: {
            navUrl: 'career',
            navText: secondaryNav[0],
            useAbsolute: null,
            configuration: null,
            __typename: 'NavLinkItem'
          },
          children: null,
          __typename: 'NavElement'
        }],
        secondaryNav: null,
        userNav: userNavData,
        languageSelector: {
          languageSelectorChildren: languageSelector.children,
          languageSelectorConfiguration: {
            navType: 'LANGUAGE_SELECTOR',
            iconPosition: '1',
            __typename: 'NavConfiguration'
          },
          __typename: 'LanguageSelectorElement'
        },
        __typename: 'NavData'
      }
    },
    QnaMember: {
      desktop: {
        primaryNav: [{
          parent: {
            navUrl: 'cspofferinterstitial/ib',
            navText: qnaNav[0],
            useAbsolute: null,
            configuration: {
              externalApi: null,
              navIconUrl: null,
              elementClassName: 'QNA_BUTTON',
              elementId: null,
              iconPosition: null,
              navType: null,
              __typename: 'NavConfiguration'
            },
            __typename: 'NavLinkItem'
          },
          children: null,
          __typename: 'NavElement'
        }],
        secondaryNav: null,
        userNav: qnaUserNavData,
        languageSelector: {
          languageSelectorChildren: languageSelector.children,
          languageSelectorConfiguration: {
            navType: 'LANGUAGE_SELECTOR',
            iconPosition: '1',
            __typename: 'NavConfiguration'
          },
          __typename: 'LanguageSelectorElement'
        },
        __typename: 'NavData'
      }
    },
    QnaSubscriber: {
      desktop: {
        primaryNav: null,
        secondaryNav: null,
        userNav: qnaUserNavData,
        languageSelector: {
          languageSelectorChildren: languageSelector.children,
          languageSelectorConfiguration: {
            navType: 'LANGUAGE_SELECTOR',
            iconPosition: '1',
            __typename: 'NavConfiguration'
          },
          __typename: 'LanguageSelectorElement'
        },
        __typename: 'NavData'
      }
    },
    QnaResubscribe: {
      desktop: {
        primaryNav: [{
          parent: {
            navUrl: 'cspofferinterstitial/ib',
            navText: qnaNav[1],
            useAbsolute: null,
            configuration: {
              externalApi: null,
              navIconUrl: null,
              elementClassName: 'QNA_BUTTON',
              elementId: null,
              iconPosition: null,
              navType: null,
              __typename: 'NavConfiguration'
            },
            __typename: 'NavLinkItem'
          },
          children: null,
          __typename: 'NavElement'
        }],
        secondaryNav: null,
        userNav: qnaUserNavData,
        languageSelector: {
          languageSelectorChildren: languageSelector.children,
          languageSelectorConfiguration: {
            navType: 'LANGUAGE_SELECTOR',
            iconPosition: '1',
            __typename: 'NavConfiguration'
          },
          __typename: 'LanguageSelectorElement'
        },
        __typename: 'NavData'
      }
    },
    QnaResume: {
      desktop: {
        primaryNav: [{
          parent: {
            navUrl: 'cspofferinterstitial/ib',
            navText: qnaNav[2],
            useAbsolute: null,
            configuration: {
              externalApi: null,
              navIconUrl: null,
              elementClassName: 'QNA_BUTTON',
              elementId: null,
              iconPosition: null,
              navType: null,
              __typename: 'NavConfiguration'
            },
            __typename: 'NavLinkItem'
          },
          children: null,
          __typename: 'NavElement'
        }],
        secondaryNav: null,
        userNav: userNavData,
        languageSelector: {
          languageSelectorChildren: languageSelector.children,
          languageSelectorConfiguration: {
            navType: 'LANGUAGE_SELECTOR',
            iconPosition: '1',
            __typename: 'NavConfiguration'
          },
          __typename: 'LanguageSelectorElement'
        },
        __typename: 'NavData'
      }
    },
    QnaContent: {
      desktop: {
        primaryNav: null,
        secondaryNav: null,
        userNav: qnaUserNavData,
        languageSelector: {
          languageSelectorChildren: languageSelector.children,
          languageSelectorConfiguration: {
            navType: 'LANGUAGE_SELECTOR',
            iconPosition: '1',
            __typename: 'NavConfiguration'
          },
          __typename: 'LanguageSelectorElement'
        },
        __typename: 'NavData'
      }
    }
  };
};